/**
 * @generated SignedSource<<b6553a188613682c478e2da5d4234119>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateNotificationSubscriptions = {
  marketing?: boolean | null;
  marketingContactChannels?: ReadonlyArray<string> | null;
  surveyInviteContactChannels?: ReadonlyArray<string> | null;
  surveyInvites?: boolean | null;
  token?: string | null;
};
export type useEnablePushNotificationsMutation$variables = {
  input: UpdateNotificationSubscriptions;
};
export type useEnablePushNotificationsMutation$data = {
  readonly updateNotificationContactChannelSubscriptions: {
    readonly message: string | null;
    readonly notificationSubscriptions: {
      readonly id: string;
      readonly surveyInviteContactChannels: ReadonlyArray<string> | null;
    };
  } | null;
};
export type useEnablePushNotificationsMutation = {
  response: useEnablePushNotificationsMutation$data;
  variables: useEnablePushNotificationsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateNotificationSubscriptionsResponse",
    "kind": "LinkedField",
    "name": "updateNotificationContactChannelSubscriptions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surveyInviteContactChannels",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useEnablePushNotificationsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEnablePushNotificationsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ab0d1da4720fb1542644566c0d994d04",
    "id": null,
    "metadata": {},
    "name": "useEnablePushNotificationsMutation",
    "operationKind": "mutation",
    "text": "mutation useEnablePushNotificationsMutation(\n  $input: UpdateNotificationSubscriptions!\n) {\n  updateNotificationContactChannelSubscriptions(input: $input) {\n    message\n    notificationSubscriptions {\n      id\n      surveyInviteContactChannels\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c41127dc9f09116ea5dca6f52204d2b4";

export default node;
